import {TermFilter} from '@dofleini/query-builder';
import {Checkbox, Form} from 'antd';
import classNames from 'classnames';
import isEmpty from 'lodash/isEmpty';
import map from 'lodash/map';
import PropTypes from 'prop-types';
import React, {useCallback, useMemo} from 'react';

import FilterContent from '@/components/TableFilters/components/FilterContent';

export const BOOL_ENUM = {
  TRUE: 'true',
  FALSE: 'false',
};

const getByField = (field, value) => {
  switch (value) {
    case BOOL_ENUM.TRUE:
      return new TermFilter({field, value: true}).toQuery();
    case BOOL_ENUM.FALSE:
    default:
      return new TermFilter({field, value: false}).toQuery();
  }
};

export const BoolComponent = ({t, applyFilter, filter, currentValue = [], onFinishRequest}) => {
  const options = useMemo(() => map(BOOL_ENUM, value => ({value, label: filter[`${value}Text`]})), [filter]);

  const onFinish = useCallback(({value: values}) => {
    if (isEmpty(values))
      return;

    if (onFinishRequest) {
      onFinishRequest({value: values});
      return;
    }

    const filters = map(values, value => {
      if (!Array.isArray(filter.field)) {
        return getByField(filter.field, value);
      } else {
        return {'type': 'OR', 'filters': filter.field?.map((e) => getByField(e, value))};
      }
    });
    return applyFilter({type: 'OR', filters});
  }, [applyFilter, filter.field, onFinishRequest]);

  return (
    <Form onFinish={onFinish}>
      <FilterContent t={t}>
        <Form.Item name="value" className="m-0" initialValue={currentValue?.map(e => '' + e) || []}>
          <Checkbox.Group className="w-full">
            <div className="w-full flex flex-col max-h-300px">
              {
                options.map(({value, label}) => (
                  <Checkbox className={classNames('mx-0 my-px p-2')} key={value} value={value}>
                    {t(label)}
                  </Checkbox>
                ))
              }
            </div>
          </Checkbox.Group>
        </Form.Item>
      </FilterContent>
    </Form>
  );
};

BoolComponent.propTypes = {
  filter: PropTypes.object,
  currentValue: PropTypes.array,
  t: PropTypes.func,
  onFinishRequest: PropTypes.func,
  applyFilter: PropTypes.func,
};

export const ValueBool = ({filterValue, t, filter}) => {
  const options = useMemo(() => map(filterValue.filters,
    ({value}) => {
      const text = filter[`${String(value)}Text`];
      return t(text);
    }).join(', '), [filterValue.filters, filter, t]);

  return <p className="m-0 break-world leading-snug whitespace-pre-wrap">{options}</p>;
};

ValueBool.propTypes = {
  filter: PropTypes.object,
  t: PropTypes.func,
  filterValue: PropTypes.any,
};
